import { Typography } from '@material-ui/core'
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff'

import { getTranslate } from '../../localization'
import { DATE } from './SearchWidgetArrivalDate'
import useStyles from './styles/SearchWidgetArrivalDate.styles'

const SearchWidgetDepartureDate: React.FC<DATE> = ({
  data,
  selectingStartDate
}) => {
  const classes = useStyles()
  const { year, month, day } = data

  return (
    <div className={classes.root}>
      <div className={classes.labelHeader}>
        <FlightTakeoffIcon
          className={[
            classes.icon,
            selectingStartDate ? '' : classes.selectedIcon
          ].join(' ')}
        />
        <Typography
          variant="h4"
          className={[
            classes.title,
            selectingStartDate ? '' : classes.selectedIcon
          ].join(' ')}>
          {getTranslate('Departure')}
        </Typography>
      </div>
      <div className={classes.dateContainer}>
        <div className={classes.dayContainer}>
          <Typography variant="h5" color="primary" className={classes.number}>
            {day !== '' ? day : getTranslate('Select date')}
          </Typography>
        </div>
        <div className={classes.monthContainer}>
          <Typography variant="h5" className={classes.title2}>
            {month} {year}
          </Typography>
        </div>
      </div>
    </div>
  )
}
export default SearchWidgetDepartureDate
